import { ISelectOption } from '../utils/interfaces/ISelectOptions';
import store from '../store';

interface ICountryNationality {
  code: string;
  countryNames: Dict<string>;
  nationalities: Dict<string>;
}

const getLanguage = () => store.getState().app.language;

export const COUNTRY_NATIONALITY_LIST: ICountryNationality[] = [
  {
    code: 'AF',
    countryNames: {
      en: 'Afghanistan',
      de: 'Afghanistan',
      it: 'Afghanistan',
    },
    nationalities: {
      en: 'Afghan',
      de: 'afghanisch',
      it: 'afghano',
    },
  },
  {
    code: 'AL',
    countryNames: {
      en: 'Albania',
      de: 'Albanien',
      it: 'Albania',
    },
    nationalities: {
      en: 'Albanian',
      de: 'albanisch',
      it: 'albanese',
    },
  },
  {
    code: 'DZ',
    countryNames: {
      en: 'Algeria',
      de: 'Algerien',
      it: 'Algeria',
    },
    nationalities: {
      en: 'Algerian',
      de: 'algerisch',
      it: 'algerino',
    },
  },
  {
    code: 'AD',
    countryNames: {
      en: 'Andorra',
      de: 'Andorra',
      it: 'Andorra',
    },
    nationalities: {
      en: 'Andorran',
      de: 'andorranisch',
      it: 'andorrano',
    },
  },
  {
    code: 'AO',
    countryNames: {
      en: 'Angola',
      de: 'Angola',
      it: 'Angola',
    },
    nationalities: {
      en: 'Angolan',
      de: 'angolanisch',
      it: 'angolano',
    },
  },
  {
    code: 'AQ',
    countryNames: {
      en: 'Antarctica',
      de: 'Antarctica',
      it: 'Antartide',
    },
    nationalities: {
      en: 'Antarctic',
      de: 'antarktisch',
      it: 'antartico',
    },
  },
  {
    code: 'AG',
    countryNames: {
      en: 'Antigua and Barbuda',
      de: 'Antigua und Barbuda',
      it: 'Antigua e Barbuda',
    },
    nationalities: {
      en: 'Antiguan or Barbudan',
      de: 'antiguanisch',
      it: 'antiguano o barbudano',
    },
  },
  {
    code: 'AR',
    countryNames: {
      en: 'Argentina',
      de: 'Argentinien',
      it: 'Argentina',
    },
    nationalities: {
      en: 'Argentine',
      de: 'argentinisch',
      it: 'argentino',
    },
  },
  {
    code: 'AM',
    countryNames: {
      en: 'Armenia',
      de: 'Armenien',
      it: 'Armenia',
    },
    nationalities: {
      en: 'Armenian',
      de: 'armenisch',
      it: 'armeno',
    },
  },
  {
    code: 'AU',
    countryNames: {
      en: 'Australia',
      de: 'Australien',
      it: 'Australia',
    },
    nationalities: {
      en: 'Australian',
      de: 'australisch',
      it: 'australiano',
    },
  },
  {
    code: 'AT',
    countryNames: {
      en: 'Austria',
      de: 'Österreich',
      it: 'Austria',
    },
    nationalities: {
      en: 'Austrian',
      de: 'österreichisch',
      it: 'austriaco',
    },
  },
  {
    code: 'AZ',
    countryNames: {
      en: 'Azerbaijan',
      de: 'Aserbaidschan',
      it: 'Azerbaigian',
    },
    nationalities: {
      en: 'Azerbaijani, Azeri',
      de: 'aserbaidschanisch',
      it: 'azero',
    },
  },
  {
    code: 'BS',
    countryNames: {
      en: 'Bahamas',
      de: 'Bahamas',
      it: 'Bahamas',
    },
    nationalities: {
      en: 'bahamaisch',
      de: 'bahamaisch',
      it: 'bahamense',
    },
  },
  {
    code: 'BH',
    countryNames: {
      en: 'Bahrain',
      de: 'Bahrain',
      it: 'Bahrein',
    },
    nationalities: {
      en: 'Bahraini',
      de: 'bahrainisch',
      it: 'bahreinita',
    },
  },
  {
    code: 'BD',
    countryNames: {
      en: 'Bangladesh',
      de: 'Bangladesch',
      it: 'Bangladesh',
    },
    nationalities: {
      en: 'Bangladeshi',
      de: 'bangladeschisch',
      it: 'bengalese',
    },
  },
  {
    code: 'BB',
    countryNames: {
      en: 'Barbados',
      de: 'Barbados',
      it: 'Barbados',
    },
    nationalities: {
      en: 'Barbadian',
      de: 'barbadisch',
      it: 'barbadiano',
    },
  },
  {
    code: 'BY',
    countryNames: {
      en: 'Belarus',
      de: 'Weißrussland',
      it: 'Bielorussia',
    },
    nationalities: {
      en: 'Belarusian',
      de: 'belarussisch',
      it: 'bielorusso',
    },
  },
  {
    code: 'BE',
    countryNames: {
      en: 'Belgium',
      de: 'Belgien',
      it: 'Belgio',
    },
    nationalities: {
      en: 'Belgian',
      de: 'belgisch',
      it: 'belga',
    },
  },
  {
    code: 'BZ',
    countryNames: {
      en: 'Belize',
      de: 'Belize',
      it: 'Belize',
    },
    nationalities: {
      en: 'Belizean',
      de: 'belizisch',
      it: 'beliziano',
    },
  },
  {
    code: 'BJ',
    countryNames: {
      en: 'Benin',
      de: 'Benin',
      it: 'Benin',
    },
    nationalities: {
      en: 'Beninese, Beninois',
      de: 'beninisch',
      it: 'beninese',
    },
  },
  {
    code: 'BT',
    countryNames: {
      en: 'Bhutan',
      de: 'Bhutan',
      it: 'Bhutan',
    },
    nationalities: {
      en: 'Bhutanese',
      de: 'bhutanisch',
      it: 'bhutanese',
    },
  },
  {
    code: 'BO',
    countryNames: {
      en: 'Bolivia (Plurinational State of)',
      de: 'Bolivien',
      it: 'Bolivia',
    },
    nationalities: {
      en: 'Bolivian',
      de: 'bolivianisch',
      it: 'boliviano',
    },
  },
  {
    code: 'BA',
    countryNames: {
      en: 'Bosnia and Herzegovina',
      de: 'Bosnien und Herzegowina',
      it: 'Bosnia ed Erzegovina',
    },
    nationalities: {
      en: 'Bosnian or Herzegovinian',
      de: 'boschnisch-herzegowinisch',
      it: 'bosniaco o erzegovino',
    },
  },
  {
    code: 'BW',
    countryNames: {
      en: 'Botswana',
      de: 'Botsuana',
      it: 'Botswana',
    },
    nationalities: {
      en: 'Motswana, Botswanan',
      de: 'botsuanisch',
      it: 'botswano',
    },
  },
  {
    code: 'BR',
    countryNames: {
      en: 'Brazil',
      de: 'Brasilien',
      it: 'Brasile',
    },
    nationalities: {
      en: 'Brazilian',
      de: 'brasilianisch',
      it: 'brasiliano',
    },
  },
  {
    code: 'BN',
    countryNames: {
      en: 'Brunei Darussalam',
      de: 'Brunei',
      it: 'Brunei',
    },
    nationalities: {
      en: 'Bruneian',
      de: 'bruneiisch',
      it: 'bruneiano',
    },
  },
  {
    code: 'BG',
    countryNames: {
      en: 'Bulgaria',
      de: 'Bulgarien',
      it: 'Bulgaria',
    },
    nationalities: {
      en: 'Bulgarian',
      de: 'bulgarisch',
      it: 'bulgaro',
    },
  },
  {
    code: 'BF',
    countryNames: {
      en: 'Burkina Faso',
      de: 'Burkina Faso',
      it: 'Burkina Faso',
    },
    nationalities: {
      en: 'Burkinabé',
      de: 'burkinisch',
      it: 'burkinabé',
    },
  },
  {
    code: 'BI',
    countryNames: {
      en: 'Burundi',
      de: 'Burundi',
      it: 'Burundi',
    },
    nationalities: {
      en: 'Burundian',
      de: 'burundisch',
      it: 'burundese',
    },
  },
  {
    code: 'CV',
    countryNames: {
      en: 'Cabo Verde',
      de: 'Kap Verde',
      it: 'Capo Verde',
    },
    nationalities: {
      en: 'Cabo Verdean',
      de: 'cabo-verdisch',
      it: 'capoverdiano',
    },
  },
  {
    code: 'KH',
    countryNames: {
      en: 'Cambodia',
      de: 'Kambodscha',
      it: 'Cambogia',
    },
    nationalities: {
      en: 'Cambodian',
      de: 'kambodschanisch',
      it: 'cambogiano',
    },
  },
  {
    code: 'CM',
    countryNames: {
      en: 'Cameroon',
      de: 'Kamerun',
      it: 'Camerun',
    },
    nationalities: {
      en: 'Cameroonian',
      de: 'kamerunisch',
      it: 'camerunese',
    },
  },
  {
    code: 'CA',
    countryNames: {
      en: 'Canada',
      de: 'Kanada',
      it: 'Canada',
    },
    nationalities: {
      en: 'Canadian',
      de: 'kanadisch',
      it: 'canadese',
    },
  },
  {
    code: 'CF',
    countryNames: {
      en: 'Central African Republic',
      de: 'Zentralafrikanische Republik',
      it: 'Repubblica Centrafricana',
    },
    nationalities: {
      en: 'Central African',
      de: 'zentralafrikanisch',
      it: 'centrafricano',
    },
  },
  {
    code: 'TD',
    countryNames: {
      en: 'Chad',
      de: 'Tschad',
      it: 'Ciad',
    },
    nationalities: {
      en: 'Chadian',
      de: 'tschadisch',
      it: 'ciadiano',
    },
  },
  {
    code: 'CL',
    countryNames: {
      en: 'Chile',
      de: 'Chile',
      it: 'Cile',
    },
    nationalities: {
      en: 'Chilean',
      de: 'chilenisch',
      it: 'cileno',
    },
  },
  {
    code: 'CN',
    countryNames: {
      en: 'China',
      de: 'China',
      it: 'Cina',
    },
    nationalities: {
      en: 'Chinese',
      de: 'chinesisch',
      it: 'cinese',
    },
  },
  {
    code: 'CO',
    countryNames: {
      en: 'Colombia',
      de: 'Kolumbien',
      it: 'Colombia',
    },
    nationalities: {
      en: 'Colombian',
      de: 'kolumbianisch',
      it: 'colombiano',
    },
  },
  {
    code: 'KM',
    countryNames: {
      en: 'Comoros',
      de: 'Komoren',
      it: 'Comore',
    },
    nationalities: {
      en: 'Comoran, Comorian',
      de: 'komorisch',
      it: 'comoriano',
    },
  },
  {
    code: 'CG',
    countryNames: {
      en: 'Congo (Republic of the)',
      de: 'Republik Kongo',
      it: 'Congo',
    },
    nationalities: {
      en: 'Congolese',
      de: 'kongolesisch',
      it: 'congolese',
    },
  },
  {
    code: 'CD',
    countryNames: {
      en: 'Congo (Democratic Republic of the)',
      de: 'Demokratische Republik Kongo',
      it: 'Repubblica Democratica del Congo',
    },
    nationalities: {
      en: 'Congolese',
      de: 'der demokratischen republik kongo',
      it: 'congolese',
    },
  },
  {
    code: 'CK',
    countryNames: {
      en: 'Cook Islands',
      de: 'Cookinseln',
      it: 'Isole Cook',
    },
    nationalities: {
      en: 'Cook Island',
      de: 'der cookinseln',
      it: 'delle Isole Cook',
    },
  },
  {
    code: 'CR',
    countryNames: {
      en: 'Costa Rica',
      de: 'Costa Rica',
      it: 'Costa Rica',
    },
    nationalities: {
      en: 'Costa Rican',
      de: 'costa-ricanisch',
      it: 'costaricano',
    },
  },
  {
    code: 'CI',
    countryNames: {
      en: "Côte d'Ivoire",
      de: 'Elfenbeinküste',
      it: "Costa d'Avorio",
    },
    nationalities: {
      en: 'Ivorian',
      de: 'ivorisch',
      it: 'ivoriano',
    },
  },
  {
    code: 'HR',
    countryNames: {
      en: 'Croatia',
      de: 'Kroatien',
      it: 'Croazia',
    },
    nationalities: {
      en: 'Croatian',
      de: 'kroatisch',
      it: 'croato',
    },
  },
  {
    code: 'CU',
    countryNames: {
      en: 'Cuba',
      de: 'Kuba',
      it: 'Cuba',
    },
    nationalities: {
      en: 'Cuban',
      de: 'kubanisch',
      it: 'cubano',
    },
  },
  {
    code: 'CY',
    countryNames: {
      en: 'Cyprus',
      de: 'Zypern',
      it: 'Cipro',
    },
    nationalities: {
      en: 'Cypriot',
      de: 'zyprisch',
      it: 'cipriota',
    },
  },
  {
    code: 'CZ',
    countryNames: {
      en: 'Czech Republic',
      de: 'Tschechien',
      it: 'Repubblica Ceca',
    },
    nationalities: {
      en: 'Czech',
      de: 'tschechisch',
      it: 'ceco',
    },
  },
  {
    code: 'DK',
    countryNames: {
      en: 'Denmark',
      de: 'Dänemark',
      it: 'Danimarca',
    },
    nationalities: {
      en: 'Danish',
      de: 'dänisch',
      it: 'danese',
    },
  },
  {
    code: 'DJ',
    countryNames: {
      en: 'Djibouti',
      de: 'Dschibuti',
      it: 'Gibuti',
    },
    nationalities: {
      en: 'Djiboutian',
      de: 'dschibutisch',
      it: 'gibutiano',
    },
  },
  {
    code: 'DM',
    countryNames: {
      en: 'Dominica',
      de: 'Dominica',
      it: 'Dominica',
    },
    nationalities: {
      en: 'Dominican',
      de: 'dominicanisch',
      it: 'dominicense',
    },
  },
  {
    code: 'DO',
    countryNames: {
      en: 'Dominican Republic',
      de: 'Dominikanische Republik',
      it: 'Repubblica Dominicana',
    },
    nationalities: {
      en: 'Dominican',
      de: 'dominikanisch',
      it: 'dominicano',
    },
  },
  {
    code: 'EC',
    countryNames: {
      en: 'Ecuador',
      de: 'Ecuador',
      it: 'Ecuador',
    },
    nationalities: {
      en: 'Ecuadorian',
      de: 'ecuadorianisch',
      it: 'ecuadoriano',
    },
  },
  {
    code: 'EG',
    countryNames: {
      en: 'Egypt',
      de: 'Ägypten',
      it: 'Egitto',
    },
    nationalities: {
      en: 'Egyptian',
      de: 'ägyyptisch',
      it: 'egiziano',
    },
  },
  {
    code: 'SV',
    countryNames: {
      en: 'El Salvador',
      de: 'El Salvador',
      it: 'El Salvador',
    },
    nationalities: {
      en: 'Salvadoran',
      de: 'salvadorianisch',
      it: 'salvadoregno',
    },
  },
  {
    code: 'GQ',
    countryNames: {
      en: 'Equatorial Guinea',
      de: 'Äquatorialguinea',
      it: 'Guinea Equatoriale',
    },
    nationalities: {
      en: 'Equatorial Guinean, Equatoguinean',
      de: 'äquatorialguineisch',
      it: 'guineano equatoguineano',
    },
  },
  {
    code: 'ER',
    countryNames: {
      en: 'Eritrea',
      de: 'Eritrea',
      it: 'Eritrea',
    },
    nationalities: {
      en: 'Eritrean',
      de: 'eritreisch',
      it: 'eritreo',
    },
  },
  {
    code: 'EE',
    countryNames: {
      en: 'Estonia',
      de: 'Estland',
      it: 'Estonia',
    },
    nationalities: {
      en: 'Estonian',
      de: 'estnisch',
      it: 'estone',
    },
  },
  {
    code: 'ET',
    countryNames: {
      en: 'Ethiopia',
      de: 'Äthiopien',
      it: 'Etiopia',
    },
    nationalities: {
      en: 'Ethiopian',
      de: 'äthiopisch',
      it: 'etiope',
    },
  },
  {
    code: 'FO',
    countryNames: {
      en: 'Faroe Islands',
      de: 'Färöer',
      it: 'Isole Fær Øer',
    },
    nationalities: {
      en: 'Faroese',
      de: 'färöisch',
      it: 'faronese',
    },
  },
  {
    code: 'FJ',
    countryNames: {
      en: 'Fiji',
      de: 'Fidschi',
      it: 'Figi',
    },
    nationalities: {
      en: 'Fijian',
      de: 'fidschianisch',
      it: 'figiano',
    },
  },
  {
    code: 'FI',
    countryNames: {
      en: 'Finland',
      de: 'Finnland',
      it: 'Finlandia',
    },
    nationalities: {
      en: 'Finnish',
      de: 'finnisch',
      it: 'finlandese',
    },
  },
  {
    code: 'FR',
    countryNames: {
      en: 'France',
      de: 'Frankreich',
      it: 'Francia',
    },
    nationalities: {
      en: 'French',
      de: 'französisch',
      it: 'francese',
    },
  },
  {
    code: 'GA',
    countryNames: {
      en: 'Gabon',
      de: 'Gabun',
      it: 'Gabon',
    },
    nationalities: {
      en: 'Gabonese',
      de: 'gabunisch',
      it: 'gabonese',
    },
  },
  {
    code: 'GM',
    countryNames: {
      en: 'Gambia',
      de: 'Gambia',
      it: 'Gambia',
    },
    nationalities: {
      en: 'Gambian',
      de: 'gambisch',
      it: 'gambiano',
    },
  },
  {
    code: 'GE',
    countryNames: {
      en: 'Georgia',
      de: 'Georgien',
      it: 'Georgia',
    },
    nationalities: {
      en: 'Georgian',
      de: 'georgisch',
      it: 'georgiano',
    },
  },
  {
    code: 'DE',
    countryNames: {
      en: 'Germany',
      de: 'Deutschland',
      it: 'Germania',
    },
    nationalities: {
      en: 'German',
      de: 'deutsch',
      it: 'tedesco',
    },
  },
  {
    code: 'GH',
    countryNames: {
      en: 'Ghana',
      de: 'Ghana',
      it: 'Ghana',
    },
    nationalities: {
      en: 'Ghanaian',
      de: 'ghanaisch',
      it: 'ghanese',
    },
  },
  {
    code: 'GR',
    countryNames: {
      en: 'Greece',
      de: 'Griechenland',
      it: 'Grecia',
    },
    nationalities: {
      en: 'Greek, Hellenic',
      de: 'griechisch',
      it: 'greco',
    },
  },
  {
    code: 'GD',
    countryNames: {
      en: 'Grenada',
      de: 'Grenada',
      it: 'Grenada',
    },
    nationalities: {
      en: 'Grenadian',
      de: 'grenadisch',
      it: 'grenadiano',
    },
  },
  {
    code: 'GT',
    countryNames: {
      en: 'Guatemala',
      de: 'Guatemala',
      it: 'Guatemala',
    },
    nationalities: {
      en: 'Guatemalan',
      de: 'guatemaltekisch',
      it: 'guatemalteco',
    },
  },
  {
    code: 'GN',
    countryNames: {
      en: 'Guinea',
      de: 'Guinea',
      it: 'Guinea',
    },
    nationalities: {
      en: 'Guinean',
      de: 'guineisch',
      it: 'guineano',
    },
  },
  {
    code: 'GW',
    countryNames: {
      en: 'Guinea-Bissau',
      de: 'Guinea-Bissau',
      it: 'Guinea-Bissau',
    },
    nationalities: {
      en: 'Bissau-Guinean',
      de: 'guinea-bissauisch',
      it: 'guineano-bissauiano',
    },
  },
  {
    code: 'GY',
    countryNames: {
      en: 'Guyana',
      de: 'Guyana',
      it: 'Guyana',
    },
    nationalities: {
      en: 'Guyanese',
      de: 'guyanisch',
      it: 'guyanese',
    },
  },
  {
    code: 'HT',
    countryNames: {
      en: 'Haiti',
      de: 'Haiti',
      it: 'Haiti',
    },
    nationalities: {
      en: 'Haitian',
      de: 'haitanisch',
      it: 'haitiano',
    },
  },
  {
    code: 'VA',
    countryNames: {
      en: 'Vatican City State',
      de: 'Staat Vatikanstadt',
      it: 'Città del Vaticano',
    },
    nationalities: {
      en: 'Vatican',
      de: 'vatikanisch',
      it: 'vaticano',
    },
  },
  {
    code: 'HN',
    countryNames: {
      en: 'Honduras',
      de: 'Honduras',
      it: 'Honduras',
    },
    nationalities: {
      en: 'Honduran',
      de: 'honduranisch',
      it: 'honduregno',
    },
  },
  {
    code: 'HK',
    countryNames: {
      en: 'Hong Kong',
      de: 'Hong Kong',
      it: 'Hong Kong',
    },
    nationalities: {
      en: 'Hong Kong, Hong Kongese',
      de: 'chinesisch (hongkong)',
      it: 'hongkonghese',
    },
  },
  {
    code: 'HU',
    countryNames: {
      en: 'Hungary',
      de: 'Ungarn',
      it: 'Ungheria',
    },
    nationalities: {
      en: 'Hungarian, Magyar',
      de: 'ungarisch',
      it: 'ungherese',
    },
  },
  {
    code: 'IS',
    countryNames: {
      en: 'Iceland',
      de: 'Island',
      it: 'Islanda',
    },
    nationalities: {
      en: 'Icelandic',
      de: 'isländisch',
      it: 'islandese',
    },
  },
  {
    code: 'IN',
    countryNames: {
      en: 'India',
      de: 'Indien',
      it: 'India',
    },
    nationalities: {
      en: 'Indian',
      de: 'indisch',
      it: 'indiano',
    },
  },
  {
    code: 'ID',
    countryNames: {
      en: 'Indonesia',
      de: 'Indonesien',
      it: 'Indonesia',
    },
    nationalities: {
      en: 'Indonesian',
      de: 'indonesisch',
      it: 'indonesiano',
    },
  },
  {
    code: 'IR',
    countryNames: {
      en: 'Iran',
      de: 'Iran',
      it: 'Iran',
    },
    nationalities: {
      en: 'Iranian, Persian',
      de: 'iranisch',
      it: 'iraniano',
    },
  },
  {
    code: 'IQ',
    countryNames: {
      en: 'Iraq',
      de: 'Irak',
      it: 'Iraq',
    },
    nationalities: {
      en: 'Iraqi',
      de: 'irakisch',
      it: 'iracheno',
    },
  },
  {
    code: 'IE',
    countryNames: {
      en: 'Ireland',
      de: 'Irland',
      it: 'Irlanda',
    },
    nationalities: {
      en: 'Irish',
      de: 'irisch',
      it: 'irlandese',
    },
  },
  {
    code: 'IL',
    countryNames: {
      en: 'Israel',
      de: 'Israel',
      it: 'Israele',
    },
    nationalities: {
      en: 'Israeli',
      de: 'israelisch',
      it: 'israeliano',
    },
  },
  {
    code: 'IT',
    countryNames: {
      en: 'Italy',
      de: 'Italien',
      it: 'Italia',
    },
    nationalities: {
      en: 'Italian',
      de: 'italienisch',
      it: 'italiano',
    },
  },
  {
    code: 'JM',
    countryNames: {
      en: 'Jamaica',
      de: 'Jamaika',
      it: 'Giamaica',
    },
    nationalities: {
      en: 'Jamaican',
      de: 'jamaikanisch',
      it: 'giamaicano',
    },
  },
  {
    code: 'JP',
    countryNames: {
      en: 'Japan',
      de: 'Japan',
      it: 'Giappone',
    },
    nationalities: {
      en: 'Japanese',
      de: 'japanisch',
      it: 'giapponese',
    },
  },
  {
    code: 'JO',
    countryNames: {
      en: 'Jordan',
      de: 'Jordanien',
      it: 'Giordania',
    },
    nationalities: {
      en: 'Jordanian',
      de: 'jordanisch',
      it: 'giordano',
    },
  },
  {
    code: 'KZ',
    countryNames: {
      en: 'Kazakhstan',
      de: 'Kasachstan',
      it: 'Kazakistan',
    },
    nationalities: {
      en: 'Kazakhstani, Kazakh',
      de: 'kasachisch',
      it: 'kazako',
    },
  },
  {
    code: 'KE',
    countryNames: {
      en: 'Kenya',
      de: 'Kenia',
      it: 'Kenya',
    },
    nationalities: {
      en: 'Kenyan',
      de: 'kenianisch',
      it: 'keniota',
    },
  },
  {
    code: 'KI',
    countryNames: {
      en: 'Kiribati',
      de: 'Kiribati',
      it: 'Kiribati',
    },
    nationalities: {
      en: 'I-Kiribati',
      de: 'kiribatisch',
      it: 'kiribatiano',
    },
  },
  {
    code: 'KP',
    countryNames: {
      en: "Korea (Democratic People's Republic of) ",
      de: 'Nordkorea',
      it: 'Corea del Nord',
    },
    nationalities: {
      en: 'North Korean',
      de: 'der demokratischen volksrepublik korea',
      it: 'nordcoreano',
    },
  },
  {
    code: 'KR',
    countryNames: {
      en: 'Korea (Republic of)',
      de: 'Südkorea',
      it: 'Corea del Sud',
    },
    nationalities: {
      en: 'South Korean',
      de: 'der republik korea',
      it: 'sudcoreano',
    },
  },
  {
    code: 'KW',
    countryNames: {
      en: 'Kuwait',
      de: 'Kuwait',
      it: 'Kuwait',
    },
    nationalities: {
      en: 'Kuwaiti',
      de: 'kuwaitisch',
      it: 'kuwaitiano',
    },
  },
  {
    code: 'KG',
    countryNames: {
      en: 'Kyrgyzstan',
      de: 'Kirgisistan',
      it: 'Kirghizistan',
    },
    nationalities: {
      en: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
      de: 'kirgisisch',
      it: 'kirghizo',
    },
  },
  {
    code: 'LA',
    countryNames: {
      en: "Lao People's Democratic Republic",
      de: 'Laos',
      it: 'Laos',
    },
    nationalities: {
      en: 'Lao, Laotian',
      de: 'laotisch',
      it: 'laotiano',
    },
  },
  {
    code: 'LV',
    countryNames: {
      en: 'Latvia',
      de: 'Lettland',
      it: 'Lettonia',
    },
    nationalities: {
      en: 'Latvian',
      de: 'lettisch',
      it: 'lettone',
    },
  },
  {
    code: 'LB',
    countryNames: {
      en: 'Lebanon',
      de: 'Libanon',
      it: 'Libano',
    },
    nationalities: {
      en: 'Lebanese',
      de: 'libanesisch',
      it: 'libanese',
    },
  },
  {
    code: 'LS',
    countryNames: {
      en: 'Lesotho',
      de: 'Lesotho',
      it: 'Lesotho',
    },
    nationalities: {
      en: 'Basotho',
      de: 'lesothisch',
      it: 'lesothiano',
    },
  },
  {
    code: 'LR',
    countryNames: {
      en: 'Liberia',
      de: 'Liberia',
      it: 'Liberia',
    },
    nationalities: {
      en: 'Liberian',
      de: 'liberianisch',
      it: 'liberiano',
    },
  },
  {
    code: 'LY',
    countryNames: {
      en: 'Libya',
      de: 'Libyen',
      it: 'Libia',
    },
    nationalities: {
      en: 'Libyan',
      de: 'libysch',
      it: 'libico',
    },
  },
  {
    code: 'LI',
    countryNames: {
      en: 'Liechtenstein',
      de: 'Liechtenstein',
      it: 'Liechtenstein',
    },
    nationalities: {
      en: 'Liechtenstein',
      de: 'liechtensteinisch',
      it: 'liechtensteinese',
    },
  },
  {
    code: 'LT',
    countryNames: {
      en: 'Lithuania',
      de: 'Litauen',
      it: 'Lituania',
    },
    nationalities: {
      en: 'Lithuanian',
      de: 'litauisch',
      it: 'lituano',
    },
  },
  {
    code: 'LU',
    countryNames: {
      en: 'Luxembourg',
      de: 'Luxemburg',
      it: 'Lussemburgo',
    },
    nationalities: {
      en: 'Luxembourg, Luxembourgish',
      de: 'luxemburgisch',
      it: 'lussemburghese',
    },
  },
  {
    code: 'MO',
    countryNames: {
      en: 'Macao',
      de: 'Macao',
      it: 'Macao',
    },
    nationalities: {
      en: 'Macanese, Chinese',
      de: 'chinesisch (macau)',
      it: 'macanese',
    },
  },
  {
    code: 'MK',
    countryNames: {
      en: 'Macedonia (the former Yugoslav Republic of)',
      de: 'Nordmazedonien',
      it: 'Macedonia del Nord',
    },
    nationalities: {
      en: 'Macedonian',
      de: 'mazedonisch',
      it: 'macedone',
    },
  },
  {
    code: 'MG',
    countryNames: {
      en: 'Madagascar',
      de: 'Madagaskar',
      it: 'Madagascar',
    },
    nationalities: {
      en: 'Malagasy',
      de: 'madagassisch',
      it: 'malgascio',
    },
  },
  {
    code: 'MW',
    countryNames: {
      en: 'Malawi',
      de: 'Malawi',
      it: 'Malawi',
    },
    nationalities: {
      en: 'Malawian',
      de: 'malawisch',
      it: 'malawiano',
    },
  },
  {
    code: 'MY',
    countryNames: {
      en: 'Malaysia',
      de: 'Malaysia',
      it: 'Malesia',
    },
    nationalities: {
      en: 'Malaysian',
      de: 'malaysisch',
      it: 'malese',
    },
  },
  {
    code: 'MV',
    countryNames: {
      en: 'Maldives',
      de: 'Malediven',
      it: 'Maldive',
    },
    nationalities: {
      en: 'Maldivian',
      de: 'maledivisch',
      it: 'maldiviano',
    },
  },
  {
    code: 'ML',
    countryNames: {
      en: 'Mali',
      de: 'Mali',
      it: 'Mali',
    },
    nationalities: {
      en: 'Malian, Malinese',
      de: 'malisch',
      it: 'maliano',
    },
  },
  {
    code: 'MT',
    countryNames: {
      en: 'Malta',
      de: 'Malta',
      it: 'Malta',
    },
    nationalities: {
      en: 'Maltese',
      de: 'maltesisch',
      it: 'maltese',
    },
  },
  {
    code: 'MH',
    countryNames: {
      en: 'Marshall Islands',
      de: 'Marshallinseln',
      it: 'Isole Marshall',
    },
    nationalities: {
      en: 'Marshallese',
      de: 'marshallisch',
      it: 'marshallese',
    },
  },
  {
    code: 'MR',
    countryNames: {
      en: 'Mauritania',
      de: 'Mauretanien',
      it: 'Mauritania',
    },
    nationalities: {
      en: 'Mauritanian',
      de: 'mauretanisch',
      it: 'mauritano',
    },
  },
  {
    code: 'MU',
    countryNames: {
      en: 'Mauritius',
      de: 'Mauritius',
      it: 'Mauritius',
    },
    nationalities: {
      en: 'Mauritian',
      de: 'mauritisch',
      it: 'mauriziano',
    },
  },
  {
    code: 'MX',
    countryNames: {
      en: 'Mexico',
      de: 'Mexiko',
      it: 'Messico',
    },
    nationalities: {
      en: 'Mexican',
      de: 'mexikanisch',
      it: 'messicano',
    },
  },
  {
    code: 'FM',
    countryNames: {
      en: 'Micronesia (Federated States of)',
      de: 'Mikronesien',
      it: 'Micronesia',
    },
    nationalities: {
      en: 'Micronesian',
      de: 'mikronesisch',
      it: 'micronesiano',
    },
  },
  {
    code: 'MD',
    countryNames: {
      en: 'Moldova (Republic of)',
      de: 'Moldawien',
      it: 'Moldavia',
    },
    nationalities: {
      en: 'Moldovan',
      de: 'moldauisch',
      it: 'moldavo',
    },
  },
  {
    code: 'MC',
    countryNames: {
      en: 'Monaco',
      de: 'Monaco',
      it: 'Monaco',
    },
    nationalities: {
      en: 'Monégasque, Monacan',
      de: 'monegassisch',
      it: 'monegasco',
    },
  },
  {
    code: 'MN',
    countryNames: {
      en: 'Mongolia',
      de: 'Mongolei',
      it: 'Mongolia',
    },
    nationalities: {
      en: 'Mongolian',
      de: 'mongolisch',
      it: 'mongolo',
    },
  },
  {
    code: 'ME',
    countryNames: {
      en: 'Montenegro',
      de: 'Montenegro',
      it: 'Montenegro',
    },
    nationalities: {
      en: 'Montenegrin',
      de: 'montenegrinisch',
      it: 'montenegrino',
    },
  },
  {
    code: 'MA',
    countryNames: {
      en: 'Morocco',
      de: 'Marokko',
      it: 'Marocco',
    },
    nationalities: {
      en: 'Moroccan',
      de: 'marrokanisch',
      it: 'marocchino',
    },
  },
  {
    code: 'MZ',
    countryNames: {
      en: 'Mozambique',
      de: 'Mosambik',
      it: 'Mozambico',
    },
    nationalities: {
      en: 'Mozambican',
      de: 'mosambikanisch',
      it: 'mozambicano',
    },
  },
  {
    code: 'MM',
    countryNames: {
      en: 'Myanmar',
      de: 'Myanmar',
      it: 'Myanmar',
    },
    nationalities: {
      en: 'Burmese',
      de: 'myanmarisch',
      it: 'birmano',
    },
  },
  {
    code: 'NA',
    countryNames: {
      en: 'Namibia',
      de: 'Namibia',
      it: 'Namibia',
    },
    nationalities: {
      en: 'Namibian',
      de: 'namibisch',
      it: 'namibiano',
    },
  },
  {
    code: 'NR',
    countryNames: {
      en: 'Nauru',
      de: 'Nauru',
      it: 'Nauru',
    },
    nationalities: {
      en: 'Nauruan',
      de: 'nauruisch',
      it: 'nauruano',
    },
  },
  {
    code: 'NP',
    countryNames: {
      en: 'Nepal',
      de: 'Nepal',
      it: 'Nepal',
    },
    nationalities: {
      en: 'Nepali, Nepalese',
      de: 'nepalesisch',
      it: 'nepalese',
    },
  },
  {
    code: 'NL',
    countryNames: {
      en: 'Netherlands',
      de: 'Niederlande',
      it: 'Paesi Bassi',
    },
    nationalities: {
      en: 'Dutch, Netherlandic',
      de: 'niederländisch',
      it: 'olandese',
    },
  },
  {
    code: 'NC',
    countryNames: {
      en: 'New Caledonia',
      de: 'New Caledonia',
      it: 'Nuova Caledonia',
    },
    nationalities: {
      en: 'New Caledonian',
      de: 'neukaledonisch',
      it: 'neo-caledoniano',
    },
  },
  {
    code: 'NZ',
    countryNames: {
      en: 'New Zealand',
      de: 'Neuseeland',
      it: 'Nuova Zelanda',
    },
    nationalities: {
      en: 'New Zealand, NZ',
      de: 'neuseeländisch',
      it: 'neozelandese',
    },
  },
  {
    code: 'NI',
    countryNames: {
      en: 'Nicaragua',
      de: 'Nicaragua',
      it: 'Nicaragua',
    },
    nationalities: {
      en: 'Nicaraguan',
      de: 'nicaraguanisch',
      it: 'nicaraguense',
    },
  },
  {
    code: 'NE',
    countryNames: {
      en: 'Niger',
      de: 'Niger',
      it: 'Niger',
    },
    nationalities: {
      en: 'Nigerien',
      de: 'nigrisch',
      it: 'nigerino',
    },
  },
  {
    code: 'NG',
    countryNames: {
      en: 'Nigeria',
      de: 'Nigeria',
      it: 'Nigeria',
    },
    nationalities: {
      en: 'Nigerian',
      de: 'nigerianisch',
      it: 'nigeriano',
    },
  },
  {
    code: 'NO',
    countryNames: {
      en: 'Norway',
      de: 'Norwegen',
      it: 'Norvegia',
    },
    nationalities: {
      en: 'Norwegian',
      de: 'norwegisch',
      it: 'norvegese',
    },
  },
  {
    code: 'OM',
    countryNames: {
      en: 'Oman',
      de: 'Oman',
      it: 'Oman',
    },
    nationalities: {
      en: 'Omani',
      de: 'osmanisch',
      it: 'omanita',
    },
  },
  {
    code: 'PK',
    countryNames: {
      en: 'Pakistan',
      de: 'Pakistan',
      it: 'Pakistan',
    },
    nationalities: {
      en: 'Pakistani',
      de: 'pakistanisch',
      it: 'pakistano',
    },
  },
  {
    code: 'PW',
    countryNames: {
      en: 'Palau',
      de: 'Palau',
      it: 'Palau',
    },
    nationalities: {
      en: 'Palauan',
      de: 'palauisch',
      it: 'palauano',
    },
  },
  {
    code: 'PS',
    countryNames: {
      en: 'Palestine, State of',
      de: 'Palästinensische Autonomiegebiete',
      it: 'Palestina',
    },
    nationalities: {
      en: 'Palestinian',
      de: 'palästinensisch',
      it: 'palestinese',
    },
  },
  {
    code: 'PA',
    countryNames: {
      en: 'Panama',
      de: 'Panama',
      it: 'Panama',
    },
    nationalities: {
      en: 'Panamanian',
      de: 'panamaisch',
      it: 'panamense',
    },
  },
  {
    code: 'PG',
    countryNames: {
      en: 'Papua New Guinea',
      de: 'Papua-Neuguinea',
      it: 'Papua Nuova Guinea',
    },
    nationalities: {
      en: 'Papua New Guinean, Papuan',
      de: 'papu-neuguineisch',
      it: 'papuano',
    },
  },
  {
    code: 'PY',
    countryNames: {
      en: 'Paraguay',
      de: 'Paraguay',
      it: 'Paraguay',
    },
    nationalities: {
      en: 'Paraguayan',
      de: 'paraguayisch',
      it: 'paraguaiano',
    },
  },
  {
    code: 'PE',
    countryNames: {
      en: 'Peru',
      de: 'Peru',
      it: 'Perù',
    },
    nationalities: {
      en: 'Peruvian',
      de: 'peruanisch',
      it: 'peruviano',
    },
  },
  {
    code: 'PH',
    countryNames: {
      en: 'Philippines',
      de: 'Philippinen',
      it: 'Filippine',
    },
    nationalities: {
      en: 'Philippine, Filipino',
      de: 'philippinisch',
      it: 'filippino',
    },
  },
  {
    code: 'PL',
    countryNames: {
      en: 'Poland',
      de: 'Polen',
      it: 'Polonia',
    },
    nationalities: {
      en: 'Polish',
      de: 'polnisch',
      it: 'polacco',
    },
  },
  {
    code: 'PT',
    countryNames: {
      en: 'Portugal',
      de: 'Portugal',
      it: 'Portogallo',
    },
    nationalities: {
      en: 'Portuguese',
      de: 'portugiesisch',
      it: 'portoghese',
    },
  },
  {
    code: 'QA',
    countryNames: {
      en: 'Qatar',
      de: 'Katar',
      it: 'Qatar',
    },
    nationalities: {
      en: 'Qatari',
      de: 'katarisch',
      it: 'qatariota',
    },
  },
  {
    code: 'RO',
    countryNames: {
      en: 'Romania',
      de: 'Rumänien',
      it: 'Romania',
    },
    nationalities: {
      en: 'Romanian',
      de: 'rumänisch',
      it: 'rumeno',
    },
  },
  {
    code: 'RU',
    countryNames: {
      en: 'Russian Federation',
      de: 'Russland',
      it: 'Russia',
    },
    nationalities: {
      en: 'Russian',
      de: 'russisch',
      it: 'russo',
    },
  },
  {
    code: 'RW',
    countryNames: {
      en: 'Rwanda',
      de: 'Ruanda',
      it: 'Ruanda',
    },
    nationalities: {
      en: 'Rwandan',
      de: 'ruandisch',
      it: 'ruandese',
    },
  },
  {
    code: 'KN',
    countryNames: {
      en: 'Saint Kitts and Nevis',
      de: 'St. Kitts und Nevis',
      it: 'Saint Kitts e Nevis',
    },
    nationalities: {
      en: 'Kittitian or Nevisian',
      de: 'von st. kitts und nevis',
      it: 'di Saint Kitts e Nevis',
    },
  },
  {
    code: 'LC',
    countryNames: {
      en: 'Saint Lucia',
      de: 'St. Lucia',
      it: 'Santa Lucia',
    },
    nationalities: {
      en: 'Saint Lucian',
      de: 'lucianisch',
      it: 'di Santa Lucia',
    },
  },
  {
    code: 'VC',
    countryNames: {
      en: 'Saint Vincent and the Grenadines',
      de: 'Saint Vincent und die Grenadinen',
      it: 'Saint Vincent e Grenadine',
    },
    nationalities: {
      en: 'Saint Vincentian, Vincentian',
      de: 'vincentisch',
      it: 'di Saint Vincent e Grenadine',
    },
  },
  {
    code: 'WS',
    countryNames: {
      en: 'Samoa',
      de: 'Samoa',
      it: 'Samoa',
    },
    nationalities: {
      en: 'Samoan',
      de: 'samoanisch',
      it: 'samoano',
    },
  },
  {
    code: 'SM',
    countryNames: {
      en: 'San Marino',
      de: 'San Marino',
      it: 'San Marino',
    },
    nationalities: {
      en: 'Sammarinese',
      de: 'san-marinesisch',
      it: 'sammarinese',
    },
  },
  {
    code: 'ST',
    countryNames: {
      en: 'Sao Tome and Principe',
      de: 'São Tomé und Príncipe',
      it: 'Sao Tomé e Príncipe',
    },
    nationalities: {
      en: 'São Toméan',
      de: 'santomeisch',
      it: 'saotomense',
    },
  },
  {
    code: 'SA',
    countryNames: {
      en: 'Saudi Arabia',
      de: 'Saudi-Arabien',
      it: 'Arabia Saudita',
    },
    nationalities: {
      en: 'Saudi, Saudi Arabian',
      de: 'saudi-arabisch',
      it: 'saudita',
    },
  },
  {
    code: 'SN',
    countryNames: {
      en: 'Senegal',
      de: 'Senegal',
      it: 'Senegal',
    },
    nationalities: {
      en: 'Senegalese',
      de: 'senegalesisch',
      it: 'senegalese',
    },
  },
  {
    code: 'RS',
    countryNames: {
      en: 'Serbia',
      de: 'Serbien',
      it: 'Serbia',
    },
    nationalities: {
      en: 'Serbian',
      de: 'serbisch',
      it: 'serbo',
    },
  },
  {
    code: 'SC',
    countryNames: {
      en: 'Seychelles',
      de: 'Seychellen',
      it: 'Seychellen',
    },
    nationalities: {
      en: 'Seychellois',
      de: 'seychellisch',
      it: 'seychellese',
    },
  },
  {
    code: 'SL',
    countryNames: {
      en: 'Sierra Leone',
      de: 'Sierra Leone',
      it: 'Sierra Leone',
    },
    nationalities: {
      en: 'Sierra Leonean',
      de: 'sierra-leonisch',
      it: 'sierraleonese',
    },
  },
  {
    code: 'SG',
    countryNames: {
      en: 'Singapore',
      de: 'Singapur',
      it: 'Singapore',
    },
    nationalities: {
      en: 'Singaporean',
      de: 'singapurisch',
      it: 'singaporese',
    },
  },
  {
    code: 'SK',
    countryNames: {
      en: 'Slovakia',
      de: 'Slowakei',
      it: 'Slovacchia',
    },
    nationalities: {
      en: 'Slovak',
      de: 'slowakisch',
      it: 'slovacco',
    },
  },
  {
    code: 'SI',
    countryNames: {
      en: 'Slovenia',
      de: 'Slowenien',
      it: 'Slovenia',
    },
    nationalities: {
      en: 'Slovenian, Slovene',
      de: 'slowenisch',
      it: 'sloveno',
    },
  },
  {
    code: 'SB',
    countryNames: {
      en: 'Solomon Islands',
      de: 'Salomonen',
      it: 'Isole Salomone',
    },
    nationalities: {
      en: 'Solomon Island',
      de: 'salomonisch',
      it: 'delle Isole Salomone',
    },
  },
  {
    code: 'SO',
    countryNames: {
      en: 'Somalia',
      de: 'Somalia',
      it: 'Somalia',
    },
    nationalities: {
      en: 'Somali, Somalian',
      de: 'somalisch',
      it: 'somalo',
    },
  },
  {
    code: 'ZA',
    countryNames: {
      en: 'South Africa',
      de: 'Südafrika',
      it: 'Sudafrica',
    },
    nationalities: {
      en: 'South African',
      de: 'südafrikanisch',
      it: 'sudafricano',
    },
  },
  {
    code: 'SS',
    countryNames: {
      en: 'South Sudan',
      de: 'Südsudan',
      it: 'Sudan del Sud',
    },
    nationalities: {
      en: 'South Sudanese',
      de: 'südsudanesisch',
      it: 'sudanese',
    },
  },
  {
    code: 'ES',
    countryNames: {
      en: 'Spain',
      de: 'Spanien',
      it: 'Spagna',
    },
    nationalities: {
      en: 'Spanish',
      de: 'spanisch',
      it: 'spagnolo',
    },
  },
  {
    code: 'LK',
    countryNames: {
      en: 'Sri Lanka',
      de: 'Sri Lanka',
      it: 'Sri Lanka',
    },
    nationalities: {
      en: 'Sri Lankan',
      de: 'sri-lankisch',
      it: 'singalese',
    },
  },
  {
    code: 'SD',
    countryNames: {
      en: 'Sudan',
      de: 'Sudan',
      it: 'Sudan',
    },
    nationalities: {
      en: 'Sudanese',
      de: 'sudanesich',
      it: 'sudanese',
    },
  },
  {
    code: 'SR',
    countryNames: {
      en: 'Suriname',
      de: 'Surinam',
      it: 'Suriname',
    },
    nationalities: {
      en: 'Surinamese',
      de: 'surinamisch',
      it: 'surinamese',
    },
  },
  {
    code: 'SZ',
    countryNames: {
      en: 'Swaziland',
      de: 'Eswatini',
      it: 'eSwatini',
    },
    nationalities: {
      en: 'Swazi',
      de: 'eswatinisch',
      it: 'swazi',
    },
  },
  {
    code: 'SE',
    countryNames: {
      en: 'Sweden',
      de: 'Schweden',
      it: 'Svezia',
    },
    nationalities: {
      en: 'Swedish',
      de: 'schwedisch',
      it: 'svedese',
    },
  },
  {
    code: 'CH',
    countryNames: {
      en: 'Switzerland',
      de: 'Schweiz',
      it: 'Svizzera',
    },
    nationalities: {
      en: 'Swiss',
      de: 'schweizerisch',
      it: 'svizzero',
    },
  },
  {
    code: 'SY',
    countryNames: {
      en: 'Syrian Arab Republic',
      de: 'Syrien',
      it: 'Siria',
    },
    nationalities: {
      en: 'Syrian',
      de: 'syrisch',
      it: 'siriano',
    },
  },
  {
    code: 'TW',
    countryNames: {
      en: 'Taiwan, Province of China',
      de: 'Taiwan',
      it: 'Taiwan',
    },
    nationalities: {
      en: 'Chinese, Taiwanese',
      de: 'taiwanisch',
      it: 'taiwanese',
    },
  },
  {
    code: 'TJ',
    countryNames: {
      en: 'Tajikistan',
      de: 'Tadschikistan',
      it: 'Tagikistan',
    },
    nationalities: {
      en: 'Tajikistani',
      de: 'tadschickisch',
      it: 'tagiko',
    },
  },
  {
    code: 'TZ',
    countryNames: {
      en: 'Tanzania, United Republic of',
      de: 'Tansania',
      it: 'Tanzania',
    },
    nationalities: {
      en: 'Tanzanian',
      de: 'tansanisch',
      it: 'tanzaniano',
    },
  },

  {
    code: 'TH',
    countryNames: {
      en: 'Thailand',
      de: 'Thailand',
      it: 'Tailandia',
    },
    nationalities: {
      en: 'Thai',
      de: 'thailändisch',
      it: 'tailandese',
    },
  },
  {
    code: 'TG',
    countryNames: {
      en: 'Togo',
      de: 'Togo',
      it: 'Togo',
    },
    nationalities: {
      en: 'Togolese',
      de: 'togoisch',
      it: 'togolese',
    },
  },
  {
    code: 'TO',
    countryNames: {
      en: 'Tonga',
      de: 'Tonga',
      it: 'Tonga',
    },
    nationalities: {
      en: 'Tongan',
      de: 'tongaisch',
      it: 'tongano',
    },
  },
  {
    code: 'TT',
    countryNames: {
      en: 'Trinidad and Tobago',
      de: 'Trinidad und Tobago',
      it: 'Trinidad e Tobago',
    },
    nationalities: {
      en: 'Trinidadian or Tobagonian',
      de: 'von trinidad und tobago',
      it: 'trinidadiano o tobagoniano',
    },
  },
  {
    code: 'TN',
    countryNames: {
      en: 'Tunisia',
      de: 'Tunesien',
      it: 'Tunisia',
    },
    nationalities: {
      en: 'Tunisian',
      de: 'tunesisch',
      it: 'tunisino',
    },
  },
  {
    code: 'TR',
    countryNames: {
      en: 'Turkey',
      de: 'Türkei',
      it: 'Turchia',
    },
    nationalities: {
      en: 'Turkish',
      de: 'türkisch',
      it: 'turco',
    },
  },
  {
    code: 'TM',
    countryNames: {
      en: 'Turkmenistan',
      de: 'Turkmenistan',
      it: 'Turkmenistan',
    },
    nationalities: {
      en: 'Turkmen',
      de: 'turkmenisch',
      it: 'turkmeno',
    },
  },
  {
    code: 'TV',
    countryNames: {
      en: 'Tuvalu',
      de: 'Tuvalu',
      it: 'Tuvalu',
    },
    nationalities: {
      en: 'Tuvaluan',
      de: 'tuvaluisch',
      it: 'tuvaluano',
    },
  },
  {
    code: 'UG',
    countryNames: {
      en: 'Uganda',
      de: 'Uganda',
      it: 'Uganda',
    },
    nationalities: {
      en: 'Ugandan',
      de: 'ugandisch',
      it: 'ugandese',
    },
  },
  {
    code: 'UA',
    countryNames: {
      en: 'Ukraine',
      de: 'Ukraine',
      it: 'Ucraina',
    },
    nationalities: {
      en: 'Ukrainian',
      de: 'ukrainisch',
      it: 'ucraino',
    },
  },
  {
    code: 'AE',
    countryNames: {
      en: 'United Arab Emirates',
      de: 'Vereinigte Arabische Emirate',
      it: 'Emirati Arabi Uniti',
    },
    nationalities: {
      en: 'Emirati, Emirian, Emiri',
      de: 'von den vereinigten arabischen emiraten',
      it: 'emiratino',
    },
  },
  {
    code: 'GB',
    countryNames: {
      en: 'United Kingdom of Great Britain and Northern Ireland',
      de: 'Vereinigtes Königreich',
      it: 'Regno Unito',
    },
    nationalities: {
      en: 'British, UK',
      de: 'britisch',
      it: 'britannico',
    },
  },
  {
    code: 'US',
    countryNames: {
      en: 'United States of America',
      de: 'Vereinigte Staaten von Amerika',
      it: "Stati Uniti d'America",
    },
    nationalities: {
      en: 'American',
      de: 'amerikanisch',
      it: 'statunitense',
    },
  },
  {
    code: 'UY',
    countryNames: {
      en: 'Uruguay',
      de: 'Uruguay',
      it: 'Uruguay',
    },
    nationalities: {
      en: 'Uruguayan',
      de: 'uruguayisch',
      it: 'uruguayano',
    },
  },
  {
    code: 'UZ',
    countryNames: {
      en: 'Uzbekistan',
      de: 'Usbekistan',
      it: 'Uzbekistan',
    },
    nationalities: {
      en: 'Uzbekistani, Uzbek',
      de: 'usbekisch',
      it: 'uzbeko',
    },
  },
  {
    code: 'VU',
    countryNames: {
      en: 'Vanuatu',
      de: 'Vanuatu',
      it: 'Vanuatu',
    },
    nationalities: {
      en: 'Ni-Vanuatu, Vanuatuan',
      de: 'vanuatuisch',
      it: 'vanuatuano',
    },
  },
  {
    code: 'VE',
    countryNames: {
      en: 'Venezuela (Bolivarian Republic of)',
      de: 'Venezuela',
      it: 'Venezuela',
    },
    nationalities: {
      en: 'Venezuelan',
      de: 'venezolanisch',
      it: 'venezuelano',
    },
  },
  {
    code: 'VN',
    countryNames: {
      en: 'Vietnam',
      de: 'Vietnam',
      it: 'Vietnam',
    },
    nationalities: {
      en: 'Vietnamese',
      de: 'vietnamesisch',
      it: 'vietnamita',
    },
  },
  {
    code: 'YE',
    countryNames: {
      en: 'Yemen',
      de: 'Jemen',
      it: 'Yemen',
    },
    nationalities: {
      en: 'Yemeni',
      de: 'jemenitisch',
      it: 'yemenita',
    },
  },
  {
    code: 'XK',
    countryNames: {
      en: 'Kosovo',
      de: 'Kosovo',
      it: 'Kosovo',
    },
    nationalities: {
      en: 'kosovarisch',
      de: 'kosovarisch',
      it: 'kosovaro',
    },
  },
  {
    code: 'ZM',
    countryNames: {
      en: 'Zambia',
      de: 'Sambia',
      it: 'Zambia',
    },
    nationalities: {
      en: 'Zambian',
      de: 'sambisch',
      it: 'zambiano',
    },
  },
  {
    code: 'ZW',
    countryNames: {
      en: 'Zimbabwe',
      de: 'Simbabwe',
      it: 'Zimbabwe',
    },
    nationalities: {
      en: 'Zimbabwean',
      de: 'simbabwisch',
      it: 'zimbabwese',
    },
  },
];

const sortAlphabetically = (source: ISelectOption[]): ISelectOption[] =>
  source.sort((a, b) => a.label.localeCompare(b.label));

export const getCountryNameByCode = (code: string): string =>
  COUNTRY_NATIONALITY_LIST.find((countryNationalityObject) => {
    return countryNationalityObject.code === code;
  })?.countryNames[getLanguage()] ?? '';

export const getCountryListOptions = (): ISelectOption[] =>
  sortAlphabetically(
    COUNTRY_NATIONALITY_LIST.map((countryNationalityObject) => ({
      key: countryNationalityObject.code,
      label:
        countryNationalityObject.countryNames[getLanguage()] ??
        countryNationalityObject.countryNames.en,
    })),
  );

export const getNationalityListOptions = (): ISelectOption[] =>
  sortAlphabetically(
    COUNTRY_NATIONALITY_LIST.map((countryNationalityObject) => ({
      key: countryNationalityObject.code,
      label:
        countryNationalityObject.nationalities[getLanguage()] ??
        countryNationalityObject.nationalities.en,
    })),
  );

export enum COUNTRY_CODE {
  'GERMANY' = 'DE',
  'ITALY' = 'IT',
}
